import * as React from 'react';

type DragEventHandlers = Pick<
	React.HTMLAttributes<HTMLDivElement>,
	'onDragEnter' | 'onDragOver' | 'onDragLeave' | 'onDrop'
>;

export function useDropTarget(onDropData: (dataTransfer: DataTransfer) => void): {
	isDragging: boolean;
	dragEventHandlers: DragEventHandlers;
} {
	const [isDragging, setIsDragging] = React.useState(false);
	const onDropDataRef = React.useRef(onDropData);

	React.useEffect(() => {
		onDropDataRef.current = onDropData;
	}, [onDropData]);

	const dragEventHandlers = React.useMemo<DragEventHandlers>(() => ({
		onDragEnter: () => {
			setIsDragging(true);
		},
		onDragOver: event => {
			event.preventDefault();
			if (!isDragging)
				setIsDragging(true);
		},
		onDragLeave: event => {
			if (event.currentTarget.contains(event.relatedTarget as Node | null))
				return;
			setIsDragging(false);
		},
		onDrop: event => {
			event.preventDefault();
			setIsDragging(false);
			onDropDataRef.current(event.dataTransfer);
		}
	}), [isDragging]);

	return { isDragging, dragEventHandlers };
}
